import { v4 } from 'node-uuid'

import { unSlugify } from './utils'

// Fake REST API implementation

const fakeDatabase = {
  tracks: {
    genesis: [{
      id: v4(),
      book: 'Genesis',
      chapter: '1',
      duration: 6,
      resource: '/content/1.mp3'
    }, {
      id: v4(),
      book: 'Genesis',
      chapter: '2',
      duration: 4.333333,
      resource: '/content/2.mp3'
    }, {
      id: v4(),
      book: 'Genesis',
      chapter: '3',
      duration: 2.89,
      resource: '/track/genesis/3'
    }, {
      id: v4(),
      book: 'Genesis',
      chapter: '4',
      duration: 6.89,
      resource: '/track/genesis/4'
    }, {
      id: v4(),
      book: 'Genesis',
      chapter: '5',
      duration: 7.5,
      resource: '/track/genesis/5'
    }]
  }
}

const delay = (ms) =>
  new Promise(resolve => setTimeout(resolve, ms))

export const fetchTracks = async (book) => {

  // delay(500).then(() => {
  //   if (book) return fakeDatabase.tracks[book]
  //   else return fakeDatabase.tracks
  // })

  var cachedTracks = []

  if ('caches' in window) {
    console.log('cathces in window')
    cachedTracks = await window.caches.open('tracks-audio').then(cache =>
      cache.keys().then(cachedRequests =>
        // requests are all of the cached tracks
        cachedRequests.map(cachedRequest => {
          const match = cachedRequest.url.match(/tracks\/([a-z0-9-]+)\/(\d+)/)
          return {
            book: unSlugify(match[1]),
            chapter: match[2]
          }
        })))
  }

  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/tracks/${book}`).then(res => res.json()).then(tracks =>
    tracks.map(track => {
      const indexOfTrackInCachedTracks = cachedTracks.findIndex(i => i.book === track.book && i.chapter == track.chapter)
      return Object.assign({}, track, {cached: indexOfTrackInCachedTracks !== -1 })
    }))
}



// WEBPACK FOOTER //
// ./src/api.js